import { Injectable, computed, signal } from '@angular/core';
import { User } from '../models/user.models';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  readonly user = signal<User | null>(null);
  readonly isAuthenticated = computed(() => this.user() !== null);

  setUser(user: User | null): void {
    this.user.set(user);
  }

  hasPermission(permission: string): boolean {
    const user = this.user();
    const roles = user?.roles ?? [user?.role ?? ''];
    const unrestricted = roles.some((role) =>
      role === 'SuperAdmin' ||
      role === 'PlatformSuperAdmin',
    );
    return unrestricted || (user?.permissions?.includes(permission) ?? false);
  }

  isBusinessOwner(): boolean {
    return this.user()?.isTenantOwner === true;
  }

  businessLandingRoute(): string {
    const user = this.user();
    if (user?.tenantId && !(user.roles?.length) && !(user.permissions?.length)) return '/franchise/dashboard';
    const routes: Array<[string[], string]> = [
      [['DASHBOARD_VIEW'], '/business/dashboard'],
      [['PROCUREMENT_COMPANY_USE', 'PROCUREMENT_NEW_PRODUCT', 'PROCUREMENT_USED_PRODUCT'], '/business/purchases'],
      [['PRODUCT_VIEW'], '/business/products'],
      [['SALE_VIEW', 'SALE_CREATE'], '/business/sales'],
      [['INVENTORY_VIEW'], '/business/inventory'],
      [['ORDER_VIEW'], '/business/orders'],
      [['FINANCE_OVERVIEW_VIEW'], '/business/finance'],
      [['REPORT_VIEW'], '/business/reports'],
      [['LOCATION_VIEW'], '/business/locations'],
      [['USER_VIEW'], '/business/users'],
      [['ROLE_VIEW'], '/business/roles'],
      [['PERMISSION_VIEW'], '/business/permissions'],
    ];
    return routes.find(([permissions]) => permissions.some((permission) => this.hasPermission(permission)))?.[1]
      ?? '/login';
  }
}
